import { useMemo } from "react";
import { db } from "../firebase";
import { updateDoc, doc } from "firebase/firestore";
import { getDistanceMiles } from "../utils/ai";

export default function DeliveryList({ user, location, foods }) {
  const deliveries = useMemo(() => {
    if (!foods) return [];
    // Only show unclaimed deliveries awaiting a courier
    let list = foods.filter(
      item => item.claimType === "delivery" && item.deliveryStatus === "pending_delivery"
    );
    list = list.map(item => {
      const distance =
        location && item.lat && item.lng
          ? getDistanceMiles(location.lat, location.lng, item.lat, item.lng)
          : null;
      return { ...item, distance };
    });
    list.sort((a, b) => (a.distance ?? 999) - (b.distance ?? 999));
    return list;
  }, [foods, location]);

  const acceptDelivery = async (id) => {
    await updateDoc(doc(db, "food_posts", id), {
      deliveryStatus: "accepted",
      courierId: user.uid
    });
  };

  return (
    <div className="space-y-3">
      {deliveries.length === 0 && (
        <p className="text-sm text-gray-400 text-center py-8">No deliveries requested right now.</p>
      )}
      {deliveries.map(item => (
        <div key={item.id} className="p-3 bg-gray-50/60 border border-gray-200/60 rounded-xl hover:bg-white/80 transition">
          <div className="flex gap-3">
            <img
              src={item.imageUrl || "/image192.png"}
              alt={item.name}
              className="w-14 h-14 rounded-lg object-cover flex-shrink-0 border border-gray-200/60"
            />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <h3 className="text-sm font-bold text-gray-800 truncate">{item.name}</h3>
                <span className="text-[10px] bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full flex-shrink-0">Awaiting courier</span>
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500">
                <span>Qty: {item.quantity}</span>
                <span>{item.hoursLeft}h left</span>
                <span>{item.distance != null ? `${item.distance.toFixed(1)} mi` : "-- mi"}</span>
              </div>
              {item.address && (
                <p className="text-xs text-gray-400 mt-1 truncate">
                  <span className="text-green-600 font-medium">Pickup:</span> {item.address}
                </p>
              )}
              {item.deliveryAddress && (
                <p className="text-xs text-gray-400 mt-0.5 truncate">
                  <span className="text-blue-600 font-medium">Drop-off:</span> {item.deliveryAddress}
                </p>
              )}
            </div>
          </div>
          <button
            onClick={() => acceptDelivery(item.id)}
            className="btn-pop mt-2 w-full bg-amber-500 text-white py-1.5 rounded-lg text-xs font-semibold hover:bg-amber-600"
          >
            Accept Delivery
          </button>
        </div>
      ))}
    </div>
  );
}
